import { render, staticRenderFns } from "./FirstScreen.vue?vue&type=template&id=17c53c26&scoped=true&"
import script from "./FirstScreen.vue?vue&type=script&lang=js&"
export * from "./FirstScreen.vue?vue&type=script&lang=js&"
import style0 from "./FirstScreen.vue?vue&type=style&index=0&id=17c53c26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c53c26",
  null
  
)

export default component.exports